import { render, staticRenderFns } from "./orderThrough-edit.vue?vue&type=template&id=5b80ae11&scoped=true"
import script from "./orderThrough-edit.vue?vue&type=script&lang=js"
export * from "./orderThrough-edit.vue?vue&type=script&lang=js"
import style0 from "./orderThrough-edit.vue?vue&type=style&index=0&id=5b80ae11&prod&lang=css"
import style1 from "./orderThrough-edit.vue?vue&type=style&index=1&id=5b80ae11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80ae11",
  null
  
)

export default component.exports